import { render } from "./PriceLogForm.vue?vue&type=template&id=6d81327f&scoped=true&ts=true"
import script from "./PriceLogForm.vue?vue&type=script&lang=ts"
export * from "./PriceLogForm.vue?vue&type=script&lang=ts"

import "./PriceLogForm.vue?vue&type=style&index=0&id=6d81327f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d81327f"]])

export default __exports__